export enum OrderandoErrorCode {
  'INVALID_TOKEN' = '1004',
  'UNKNOWN' = '0',
  'AUTH_FAILED' = '6',
  'CHARGING_PROCESS_ALREADY_RUNNING' = '3003',
  'CHARGING_POINT_NOT_FOUND' = '3004',
  'CHARGING_POINT_IN_MAINTENENCE' = '3005',
  'CHARGING_SIZE_NOT_FOUND' = '3006',
  'CHARGING_POINT_NOT_READY' = '3007',
  'CHARGING_POINT_PAYMENT_ERROR' = '3008',
}

type ErrorKey = keyof typeof OrderandoErrorCode;

function isKnownErrorCode(code: string): code is keyof typeof OrderandoErrorCode {
  return !!Object.values(OrderandoErrorCode).includes(code as any);
}

function getKeyByValue(value: string) {
  return Object.keys(OrderandoErrorCode).find(
    (key) => OrderandoErrorCode[key as ErrorKey] === value
  ) as ErrorKey | undefined;
}

export class OrderandoError extends Error {
  public errorCode: OrderandoErrorCode;

  constructor(code: string) {
    const foundErrorCode = getKeyByValue(code);
    if (foundErrorCode) {
      super(`Orderando error: ${foundErrorCode}`);
      this.errorCode = OrderandoErrorCode[foundErrorCode];
    } else {
      super(`Unkown Orderando error`);
      this.errorCode = OrderandoErrorCode.UNKNOWN;
    }
    console.error(`Orderando error:`, code);
  }

  public override toString() {
    return getKeyByValue(this.errorCode) ?? '';
  }
}
